// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentsList-LoadingIcon_cls1__3093N","cls2":"PaymentsList-LoadingIcon_cls2__1Nmvq PaymentsList-LoadingIcon_cls1__3093N"};